import React from "react";
import { SortableElement } from "react-sortable-hoc";
import {
  Input
} from "reactstrap";

const SortableItem = SortableElement(props => {
  let {
    removeItem,
    index,
    sortIndex,
    value,
    canRemove,
    handleChange,
    itemsDisabled
  } = props;
  return (
    <div className="list-item">
      <div className="handle">
        <i className="fas fa-bars" />
      </div>
      <div className="item-name">
        <Input
          value={value}
          size="sm"
          disabled={itemsDisabled}
          onChange={e => {
            handleChange(e, sortIndex);
          }}
          placeholder="Enter value"
        />
      </div>
      <div className="actions ml-auto">
        {canRemove && (
          <i
            className="fas fa-times"
            onClick={() => {
              removeItem(index);
            }}
          />
        )}
      </div>
    </div>
  );
});

export default SortableItem;



// WEBPACK FOOTER //
// ./src/system/fields/List/SortItem.jsx